var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-container"},[(_vm.messages.length > 0)?_c('ul',_vm._l((_vm.messages),function(msg,index){return _c('message-item',{key:index,attrs:{"message":msg}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }